import { OPEN_MOBILE_CHILD_LINKS_NAV_ATTR } from '../config/constants';
import { sendCustomEvent } from '../config/analytics';
import { initCart } from '../../templates/common/side-cart/side-cart';

const SHOPPING_CART_URL = '/cart';
const SHOPPING_CART_TITLE = 'Shopping Cart - Brilliant';
const proNav = document.querySelector(
  '[data-pro-pages-navigation], [data-pro-pages-smart-subnav]'
);
const headerNav = document.querySelector('[data-theme-header-navigation]');
const headerSubNav = document.querySelector(
  '[data-theme-header-navigation-sub]'
);
const headerSection = document.querySelector('#section-top-header');
let isDrawerOpen = false;
let drawerPosition = '';
let previousUrl = null;
let previousTitle = null;
let previousGaPage = null;

export const closeDrawer = (position, event = null) => {
  if (!isDrawerOpen || !position) {
    return;
  }

  const isMobileChildLinksMenuOpen = document.body.getAttribute(
    OPEN_MOBILE_CHILD_LINKS_NAV_ATTR
  );

  if (isMobileChildLinksMenuOpen === 'true') {
    document.body.setAttribute(OPEN_MOBILE_CHILD_LINKS_NAV_ATTR, 'false');

    return;
  }

  if (event) {
    event.preventDefault();
    event.stopPropagation();
    event.currentTarget.setAttribute('aria-expanded', 'false');
  }

  switch (position) {
    case 'left': {
      sendCustomEvent({
        category: 'Mobile Navigation',
        action: 'Close',
        label: 'Left drawer',
      });
      break;
    }
    case 'top': {
      sendCustomEvent({
        category: 'Desktop Navigation',
        action: 'Close',
        label: 'Top drawer',
      });
      break;
    }
    case 'right': {
      window.history.replaceState({}, previousTitle, previousUrl);
      document.title = previousTitle;

      if (window.GoogleAnalytics.ga) {
        setGoogleAnalyticsGaData(previousGaPage, previousTitle);
      }
      break;
    }
    default:
      break;
  }

  const drawer = document.querySelector(`[data-drawer-${position}]`);

  drawer.removeAttribute('tabindex');
  drawer.blur();

  document.body.removeAttribute('data-drawer-open');
  isDrawerOpen = false;
};

export const openDrawer = (position, event = null) => {
  if (!position) {
    return;
  }

  drawerPosition = position;

  if (isDrawerOpen) {
    closeDrawer(position, event);

    return;
  }

  if (event) {
    event.preventDefault();
    event.stopPropagation();
    event.currentTarget.setAttribute('aria-expanded', 'true');
  }

  const drawer = document.querySelector(`[data-drawer-${position}]`);
  const proNavHeight = proNav ? proNav.clientHeight : 0;
  const headerNavHeight = headerNav ? headerNav.clientHeight : 0;
  const headerSubNavHeight = headerSubNav ? headerSubNav.clientHeight : 0;
  const headerSectionHeight = headerSection ? headerSection.clientHeight : 0;
  const hasStickyHeader =
    document.body.getAttribute('data-sticky-header') === 'true';
  const headerVisibleSize =
    proNavHeight + (headerSectionHeight - window.scrollY);
  const topDrawerOffset = hasStickyHeader
    ? headerNavHeight + proNavHeight
    : headerVisibleSize;
  const leftDrawerOffset = topDrawerOffset - headerSubNavHeight - proNavHeight;

  switch (position) {
    case 'top': {
      drawer.style.paddingTop = `${topDrawerOffset}px`;
      sendCustomEvent({
        category: 'Desktop Navigation',
        action: 'Open',
        label: 'Top drawer',
      });

      const hotjarHamburgerMenuEventName = 'hamburger_menu_open';

      window.HotJarHelper.triggerEvent(hotjarHamburgerMenuEventName);
      break;
    }
    case 'left': {
      drawer.style.top = `${leftDrawerOffset}px`;
      sendCustomEvent({
        category: 'Mobile Navigation',
        action: 'Open',
        label: 'Left drawer',
      });
      break;
    }
    case 'right': {
      const fullCartUrl = SHOPPING_CART_URL + window.location.search;

      previousUrl = window.location.pathname + window.location.search;
      previousTitle = document.title;
      previousGaPage = window.GoogleAnalytics.getPage();

      document.title = SHOPPING_CART_TITLE;
      window.history.replaceState({}, SHOPPING_CART_TITLE, fullCartUrl);

      if (window.GoogleAnalytics.ga) {
        setGoogleAnalyticsGaData(fullCartUrl, SHOPPING_CART_TITLE);
      }
      break;
    }
    default:
      break;
  }

  drawer.setAttribute('tabindex', '-1');
  drawer.focus();

  document.body.setAttribute('data-drawer-open', position);

  isDrawerOpen = true;
};

export const initDrawers = () => {
  const leftDrawerBtn = document.querySelector('[data-drawer-btn="left"]');
  const topDrawerBtn = document.querySelector('[data-drawer-btn="top"]');
  const rightDrawerBtn = document.querySelector('[data-drawer-btn="right"]');
  const drawerBackground = document.querySelector('[data-drawer-background]');

  leftDrawerBtn?.addEventListener('click', (event) => {
    openDrawer('left', event);
  });

  topDrawerBtn?.addEventListener('click', (event) => {
    openDrawer('top', event);
  });

  rightDrawerBtn?.addEventListener('click', (event) => {
    openDrawer('right', event);

    initCart();
  });

  drawerBackground?.addEventListener('click', () => {
    if (isDrawerOpen) {
      closeDrawer(drawerPosition);
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    if (window.location.hash === '#open-cart') {
      openDrawer('right');
      initCart();
    }
  });
};

function setGoogleAnalyticsGaData(page, title) {
  window.GoogleAnalytics.ga('set', 'page', page);
  window.GoogleAnalytics.ga('set', 'title', title);
  window.GoogleAnalytics.ga('send', 'pageview');
}
